import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

interface ChatDisclaimerProps {
  className?: string;
}

export function ChatDisclaimer({ className }: ChatDisclaimerProps) {
  const { t } = useI18n();
  return (
    <p className={`text-center text-[11px] text-muted-foreground leading-relaxed max-w-3xl mx-auto ${className ?? ""}`}>
      {t("index.disclaimer")}{" "}
      <Link to="/terms" className="underline hover:text-foreground transition-colors">{t("index.terms")}</Link>
      {" "}{t("index.privacyConfirm")}{" "}
      <Link to="/privacy" className="underline hover:text-foreground transition-colors">{t("index.privacy")}</Link>
      . {t("index.cookiesSee")}{" "}
      <Link to="/cookies" className="underline hover:text-foreground transition-colors">{t("index.cookies")}</Link>
      . {t("index.sensitiveWarning")}
    </p>
  );
}
